import { GetApiData } from "../../utils/http-client";
export const LoginForm = function (data) {
  return GetApiData(`/user/login`, "POST", data, true);
};
